import { useState, useEffect, useCallback, useRef } from "react";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import { useAMGSelectedContext } from "./../../Context/GlobalContext";
import { useLanguageContext } from "./../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "./../../Context/GlobalSpinnerContext";

import equipmentStore from "./../../Stores/EquipmentStore";
import equipmentActions from "../../Actions/EquipmentActions";
import equipmentContants from "./../../Constants/EquipmentConstants";
import DatepickerEntry from "../helpers/DatepickerEntry";
import CheckboxEntry from "../helpers/CheckBoxEntry";

import ConfirmationPopUp from "../MessageBox/ConfirmationPopUp";
import SelectEntry2 from "../helpers/SelectEntry2";
import RemoveCircleOutlinedIcon from "@mui/icons-material/RemoveCircleOutlined";
import AppConstants from "../../Constants/AppConstants";

function AddEquipment() {
  const selectedAnlageG = useAMGSelectedContext();
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  const [data, setData] = useState(null);
  const [renderMe, setRenderMe] = useState(null);
  const [renderBody, setRenderBody] = useState(null);
  const [refresh, setRefresh] = useState(0);
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  let equipmentImageListInitState = {
    dropDepth: 0,
    inDropZone: false,
    fileList: [],
    filetoStringarray: [],
  };
  let equipmentFileListInitState = {
    dropDepth: 0,
    inDropZone: false,
    fileList: [],
    filetoStringarray: [],
  };
  const [equipmentImagesData, setEquipmentImagesData] = useState(
    equipmentImageListInitState,
  );
  const [equipmentFilesData, setEquipmentFilesData] = useState(
    equipmentFileListInitState,
  );
  const ImageFileInputRef = useRef(null);
  const FileInputRef = useRef(null);

  const fetchData = useCallback(async () => {
    if (selectedAnlageG !== null && selectedAnlageG !== undefined) {
      setGlobalSpinner(true);

      equipmentActions.GetEquipmentForm(selectedAnlageG);
    }
  }, [selectedAnlageG]);

  const handleKeyPress = (e) => {
    if (e.key === "Enter" || e.key === "F5") {
      setRefresh(1);
    }
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (refresh === 1) {
      setGlobalSpinner(true);
      equipmentActions.GetEquipmentForm(selectedAnlageG);
    }
  }, [refresh]);

  useEffect(() => {
    function UpdateData() {
      let _item = [];
      var res = equipmentStore.getEquipmentForm();
      res.map((item, index) => {
        item.tracker = index + 1;
        _item.push(item);
      });
      setData(_item);
      setGlobalSpinner(false);
    }

    equipmentStore.addChangeListener(
      equipmentContants.GET_EQUIPMENTFORM_SUCCESS,
      UpdateData,
    );

    return () => {
      equipmentStore.removeChangeListener(
        equipmentContants.GET_EQUIPMENTFORM_SUCCESS,
        UpdateData,
      );
    };
  }, []);

  useEffect(() => {
    function UpdateData() {
      var res = equipmentStore.getEquipmentForm();
      setData(null);
      setGlobalSpinner(false);
      toast.error(res);
    }

    equipmentStore.addChangeListener(
      equipmentContants.GET_EQUIPMENTFORM_FAILURE,
      UpdateData,
    );

    return () => {
      equipmentStore.removeChangeListener(
        equipmentContants.GET_EQUIPMENTFORM_FAILURE,
        UpdateData,
      );
    };
  }, []);

  useEffect(() => {
    function UpdateSaveMsg() {
      setData(null);
      toast.success(localization.saveSuccessForAddEquipment);
      setGlobalSpinner(false);
      setEquipmentImagesData(equipmentImageListInitState);
      setEquipmentFilesData(equipmentFileListInitState);
      setRefresh(1);
    }

    equipmentStore.addChangeListener(
      equipmentContants.INSERT_NEWEQUIPMENT_SUCCESS,
      UpdateSaveMsg,
    );

    return () => {
      equipmentStore.removeChangeListener(
        equipmentContants.INSERT_NEWEQUIPMENT_SUCCESS,
        UpdateSaveMsg,
      );
    };
  }, []);

  useEffect(() => {
    function UpdateSaveMsg() {
      const res = equipmentStore.getResult();
      setRefresh(0);
      toast.error(res);
      setGlobalSpinner(false);
    }

    equipmentStore.addChangeListener(
      equipmentContants.INSERT_NEWEQUIPMENT_FAILURE,
      UpdateSaveMsg,
    );

    return () => {
      equipmentStore.removeChangeListener(
        equipmentContants.INSERT_NEWEQUIPMENT_FAILURE,
        UpdateSaveMsg,
      );
    };
  }, []);

  const handleSubmit = (event) => {
    var pflichtText = "";

    event.preventDefault();

    var json_object = {};
    let _tempdata = [...data];
    _tempdata.map((item, index) => {
      if (item.value) {
        item["value"] = item["value"].trim();
      }
    });
    setData(_tempdata);
    // Fedor, 17.03.2022, hier musste die Logik umgebaut werden, da alle Pflichtfelder bei der Auswertung relevant sind, nicht nur die Bezeichnung

    var keinwert = false;
    var item = [];
    for (let i = 0; i <= data.length - 1; i++) {
      keinwert =
        data[i].value === null ||
        data[i].value.toString() === "" ||
        data[i].value.toString() === undefined
          ? true
          : false;
      if (data[i].mandatoryField && keinwert) {
        //MandatoryMissing
        pflichtText = localization.MandatoryMissing;
        item.push(data[i].bezeichnung);
      }
      /*switch (data[i].standardAttributId) { // je nach standardattributid wird eine andere fehlermeldung generiert
        case 0: // 0 ist eine ausnahme, da attribute aus der anlage-tabelle alle 0-id bekommen (z.B. InvNr und RFID) 
          if (keinwert && data[i].bezeichnung.toString()  != "RFID") {
            pflichtText += '\n' + (translate.invnrFehlt);
          }
          break;
        case 1:
          if (keinwert) {
            pflichtText += '\n' + (translate.bezeichnungsFehlt);
          }
          break;
        case 3:
          if (keinwert) {
            pflichtText += '\n' + (translate.bauFehlt);
          }
          break;
        case 5:
          if (keinwert) {
            pflichtText += '\n' + (translate.kostFehlt);
          }
          break;
        case 6:
          if (keinwert) {
            pflichtText += '\n' + (translate.herstellerFehlt);
          }
          break;
        case 100:
          if (keinwert) {
            pflichtText += '\n' + (translate.pruefgruppeFehlt);
          }
          break;
        default:
        // kein Bedarf 
      }*/
    }

    if (pflichtText.length > 0) {
      // setData(data);
      const Msg = () => {
        return (
          <>
            {pflichtText}
            <br />
            {item.map((key, index) => {
              return (
                <>
                  <br />
                  {key}
                </>
              );
            })}
          </>
        );
      };
      //alert(pflichtmsg + "\n" + pflichtText + "\n" + item.join("\n"));
      toast.error(<Msg />);
    } else {
      const _itemData = data.map(({ tracker, ...rest }) => {
        return rest;
      });
      json_object = {
        // ID:0,
        AnlagregruppeID: selectedAnlageG,
        //InventarNr: inventarNr,
        userId: sessionStorage.getItem("userid"),
        details: _itemData,
        documents: {
          AnlageId: AppConstants.DEFAULT_GUID,
          Files: equipmentFilesData.filetoStringarray,
        },
        EquipmentPhotos: equipmentImagesData.filetoStringarray,
      };

      setGlobalSpinner(true);
      equipmentActions.CreateEquipment(json_object);
      setRefresh(0);
    }
  };

  const handelOnChangeSelect = (value, item) => {
    ObjectUpdate(value, item);
    //setItemBgColor(item);
  };

  const handleCheckboxChange = (value, item, stdId) => {
    if (stdId === "RiskAnalysis" && value === true) {
      setConfirmationPopUpOpen(true);
      setConfirmationPopUpMsg(localization.riskAnaMsg);
      setCallbackData({
        value,
        item,
        stdId,
      });
      setEventType("RISK_CONFIRMATION");
    } else {
      ObjectUpdate(value.toString(), item);
    }
  };

  const handelOnInputchange = (value, index) => {
    ObjectUpdate(value, index);
  };

  const getBackgroundColor = (item) => {
    let _backgroundcolor = null;

    if (
      item.mandatoryField &&
      (item.value == null ||
        item.value == "" ||
        item.value == "null" ||
        item.value == undefined)
    ) {
      _backgroundcolor = { backgroundColor: "#79cdcd" };
    } else {
      if (
        item.mandatoryField &&
        (item.value !== null ||
          item.value !== "" ||
          item.value !== "null" ||
          item.value !== undefined)
      ) {
        _backgroundcolor = { backgroundColor: "#79cdcd" };
      } else {
        _backgroundcolor = { backgroundColor: "#fff" };
      }
    }
    return _backgroundcolor;
  };

  const handelOnchangeDate = (date, targetId) => {};

  const ObjectUpdate = (newValue, index) => {
    let _copyDetails = [...data];
    _copyDetails[index - 1]["value"] = newValue;
    setData(_copyDetails);
  };

  const chunkArray = (array, chunkSize) => {
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }
    return result;
  };

  useEffect(() => {
    //let backgroundcolor = null;
    let _renderBody = null;
    if (data !== null && data !== undefined) {
      const rows = chunkArray(data, 2);
      {
        _renderBody = rows.map((row, rowIndex) => {
          return (
            <div className="row" key={rowIndex}>
              {row.map((item, index) => {
                if (item.isDropdown) {
                  // if (item.bezeichnung.toLowerCase().includes('datum')) { Linda,2022-12-14
                  if (item.typ.toLowerCase().includes("datetime")) {
                    return (
                      <div className="col-6" key={item.tracker}>
                        <DatepickerEntry
                          item={item}
                          OnDateChange={handelOnchangeDate}
                        />
                      </div>
                    );
                  } else {
                    return (
                      <div className="col-6" key={item.tracker}>
                        <SelectEntry2
                          item={item}
                          OnSelectChange={handelOnChangeSelect}
                          isAddEquipment={true}
                        />
                      </div>
                    );
                  }
                } else {
                  if (item.typ.toLowerCase().includes("bool")) {
                    return (
                      <div className="col-6" key={item.tracker}>
                        <CheckboxEntry
                          item={item}
                          handleCheckboxChange={handleCheckboxChange}
                          formType="add"
                        />
                      </div>
                    );
                  } else {
                    let backgroundcolor = getBackgroundColor(item);
                    let _disable = !item.editbarFeld;
                    let _type =
                      item.typ.toLowerCase().includes("int") ||
                      item.typ.toLowerCase().includes("float")
                        ? "number"
                        : "text";

                    return (
                      <div className="form-group col-6" key={item.tracker}>
                        <label className="">
                          {item.bezeichnung.trim()}
                          {item.mandatoryField ? (
                            <>
                              <span className="requiredCls"></span>
                            </>
                          ) : (
                            <></>
                          )}
                        </label>
                        <input
                          type={_type}
                          className="form-control"
                          defaultValue={item.value || ""}
                          autoComplete="false"
                          onChange={(e) => {
                            e.preventDefault();
                            handelOnInputchange(e.target.value, item.tracker);
                          }}
                          name={item.bezeichnung}
                          id={item.standardAttributId}
                          key={item.standardAttributId}
                          disabled={!item.editbarFeld}
                          placeholder={item.bezeichnung.trim()}
                          //style={backgroundcolor}
                          step="any"
                        />
                      </div>
                    );
                  }
                }
              })}
            </div>
          );
        });
      }
    }
    setRenderBody(_renderBody);
  }, [data]);

  const handleDrop = (event, type) => {
    event.preventDefault();
    event.stopPropagation(); //make sure the event is not propagated from child to parent

    var files = [...event.dataTransfer.files]; // convert the values to a js array
    var fileName = "";
    var fileExtension = "";
    if (files && files.length > 0) {
      files.map((file) => {
        if (type === "Images" && !file.type.startsWith("image/")) {
          toast.error(localization.onlyImagesAllowed);
          return false;
        }

        if (type === "Files") {
          fileName = file.name;
          fileExtension = fileName.split(".").pop().toLowerCase();
          if (fileExtension === "exe" || fileExtension === "bat") {
            toast.error(localization.executableFilesNotAllowed);
            return false;
          }
        }
      });
      const existingFiles =
        type == "Images"
          ? equipmentImagesData.fileList.map((f) => f.name)
          : equipmentFilesData.fileList.map((f) => f.name);
      files = files.filter((f) => !existingFiles.includes(f.name));

      files.forEach((element) => {
        let reader = new FileReader();
        reader.onload = () => {
          if (type == "Images") {
            if (element.type.startsWith("image/")) {
              setEquipmentImagesData((prevState) => ({
                ...prevState,
                fileList: prevState.fileList.concat(element),
                filetoStringarray: prevState.filetoStringarray.concat({
                  Filename: element.name,
                  Filecontent: reader.result,
                  Filetyp: element.type,
                }),
              }));
            }
          } else {
            fileName = element.name;
            fileExtension = fileName.split(".").pop().toLowerCase();
            if (fileExtension != "exe" && fileExtension != "bat") {
              setEquipmentFilesData((prevState) => ({
                ...prevState,
                fileList: prevState.fileList.concat(element),
                filetoStringarray: prevState.filetoStringarray.concat({
                  Filename: element.name,
                  Filecontent: reader.result,
                  Filetyp: element.type,
                }),
              }));
            }
          }
        };
        reader.onerror = () => {};
        reader.readAsDataURL(element);
      });

      event.dataTransfer.clearData();
      if (type == "Images") {
        setEquipmentImagesData((prevState) => ({
          ...prevState,
          dropDepth: 0,
          inDropZone: false,
        }));
      } else {
        setEquipmentFilesData((prevState) => ({
          ...prevState,
          dropDepth: 0,
          inDropZone: false,
        }));
      }
    }
  };

  const handleDragOver = (e, type) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "copy";
    if (type == "Images") {
      setEquipmentImagesData((prevState) => ({
        ...prevState,
        inDropZone: true,
      }));
    } else {
      setEquipmentFilesData((prevState) => ({
        ...prevState,
        inDropZone: true,
      }));
    }
  };

  const handleDragEnter = (e, type) => {
    e.preventDefault();
    e.stopPropagation();
    if (type == "Images") {
      setEquipmentImagesData((prevState) => ({
        ...prevState,
        dropDepth: prevState.dropDepth + 1,
      }));
    } else {
      setEquipmentFilesData((prevState) => ({
        ...prevState,
        dropDepth: prevState.dropDepth + 1,
      }));
    }
  };

  const handleDragLeave = (e, type) => {
    e.preventDefault();
    e.stopPropagation();
    if (type == "Images") {
      setEquipmentImagesData((prevState) => ({
        ...prevState,
        dropDepth: prevState.dropDepth - 1,
      }));
      if (equipmentImagesData.dropDepth > 0) return;
      setEquipmentImagesData((prevState) => ({
        ...prevState,
        inDropZone: false,
      }));
    } else {
      setEquipmentFilesData((prevState) => ({
        ...prevState,
        dropDepth: prevState.dropDepth - 1,
      }));
      if (equipmentFilesData.dropDepth > 0) return;
      setEquipmentFilesData((prevState) => ({
        ...prevState,
        inDropZone: false,
      }));
    }
  };

  const equipmentFilesHandleOnchange = (event, type) => {
    var files = [...event.target.files];
    var fileName = "";
    var fileExtension = "";
    if (files && files.length > 0) {
      files.map((file) => {
        if (type === "Images" && !file.type.startsWith("image/")) {
          toast.error(localization.onlyImagesAllowed);
          return false;
        }

        if (type === "Files") {
          fileName = file.name;
          fileExtension = fileName.split(".").pop().toLowerCase();
          if (fileExtension === "exe" || fileExtension === "bat") {
            toast.error(localization.executableFilesNotAllowed);
            return false;
          }
        }
      });
      const existingFiles =
        type == "Images"
          ? equipmentImagesData.fileList.map((f) => f.name)
          : equipmentFilesData.fileList.map((f) => f.name);
      files = files.filter((f) => !existingFiles.includes(f.name));
      files.forEach((element) => {
        let reader = new FileReader();
        reader.onload = () => {
          if (type == "Images") {
            if (element.type.startsWith("image/")) {
              setEquipmentImagesData((prevState) => ({
                ...prevState,
                fileList: prevState.fileList.concat(element),
                filetoStringarray: prevState.filetoStringarray.concat({
                  Filename: element.name,
                  Filecontent: reader.result,
                  Filetyp: element.type,
                }),
                dropDepth: 0,
                inDropZone: false,
              }));
            }
            if (ImageFileInputRef.current) {
              ImageFileInputRef.current.value = ""; // Clear the input value
            }
          } else {
            fileName = element.name;
            fileExtension = fileName.split(".").pop().toLowerCase();
            if (fileExtension != "exe" && fileExtension != "bat") {
              setEquipmentFilesData((prevState) => ({
                ...prevState,
                fileList: prevState.fileList.concat(element),
                filetoStringarray: prevState.filetoStringarray.concat({
                  Filename: element.name,
                  Filecontent: reader.result,
                  Filetyp: element.type,
                }),
                dropDepth: 0,
                inDropZone: false,
              }));
            }

            if (FileInputRef.current) {
              FileInputRef.current.value = ""; // Clear the input value
            }
          }
        };
        reader.onerror = () => {};
        reader.readAsDataURL(element);
      });
    }
  };

  const removeFiles = (type, fileName) => {
    if (type == "Images") {
      let tempFiles = { ...equipmentImagesData };
      let files = tempFiles.fileList.filter((f) => f.name != fileName);
      let filesToStrArray = tempFiles.filetoStringarray.filter(
        (f) => f.Filename != fileName,
      );
      setEquipmentImagesData((prevState) => ({
        ...prevState,
        fileList: files,
        filetoStringarray: filesToStrArray,
      }));
    } else {
      let tempFiles = { ...equipmentFilesData };
      let files = tempFiles.fileList.filter((f) => f.name != fileName);
      let filesToStrArray = tempFiles.filetoStringarray.filter(
        (f) => f.Filename != fileName,
      );
      setEquipmentFilesData((prevState) => ({
        ...prevState,
        fileList: files,
        filetoStringarray: filesToStrArray,
      }));
    }
  };

  useEffect(() => {
    let _renderMe = null;
    if (renderBody !== null && renderBody !== undefined) {
      _renderMe = (
        <form
          className="form-signin"
          onSubmit={handleSubmit}
          onKeyPress={handleKeyPress}
          autoComplete="off"
        >
          {renderBody}
          <div className="fileUploadContainer">
            <div className="equipmentPictureContainer">
              <h3>{localization.pictureOfEquipment}</h3>
              {equipmentImagesData.filetoStringarray &&
              equipmentImagesData.filetoStringarray.length > 0 ? (
                <>
                  <ImageList cols={4} gap={10}>
                    {equipmentImagesData.filetoStringarray.map((f, index) => {
                      return (
                        <ImageListItem key={index}>
                          <img
                            src={f.Filecontent}
                            alt={""}
                            className="thumbnail"
                            loading="lazy"
                          />
                          <span
                            className="deleteImgCls"
                            onClick={() => {
                              removeFiles("Images", f.Filename);
                            }}
                          >
                            <RemoveCircleOutlinedIcon fontSize="large" />
                          </span>
                        </ImageListItem>
                      );
                    })}
                  </ImageList>
                </>
              ) : (
                <></>
              )}

              <div className="pictureContainer">
                <div
                  className=""
                  onDrop={(e) => handleDrop(e, "Images")}
                  onDragOver={(e) => handleDragOver(e, "Images")}
                  onDragEnter={(e) => handleDragEnter(e, "Images")}
                  onDragLeave={(e) => handleDragLeave(e, "Images")}
                >
                  <input
                    type="file"
                    ref={ImageFileInputRef}
                    className="fileUploadInput"
                    accept="image/*"
                    onChange={(e) => {
                      equipmentFilesHandleOnchange(e, "Images");
                    }}
                    multiple
                  />
                  <div>{localization.dragAndDropMessage}</div>
                  <div className="">
                    <img src="bootstrap_dist_new/bootstrap_dist/img/FileUploadPlusIcon.svg"></img>
                  </div>
                </div>
              </div>
            </div>

            <div className="equipmentFileContainer">
              <h3>{localization.equipFileStore}</h3>
              {equipmentFilesData.fileList &&
              equipmentFilesData.fileList.length > 0 ? (
                <>
                  <ul className="fileList">
                    {equipmentFilesData.fileList.map((f, index) => {
                      return (
                        <li key={index}>
                          {f.name}{" "}
                          <span
                            className="float-right"
                            onClick={() => {
                              removeFiles("Files", f.name);
                            }}
                          >
                            <RemoveCircleOutlinedIcon fontSize="large" />
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </>
              ) : (
                <></>
              )}

              <div className="pictureContainer">
                <div
                  className=""
                  onDrop={(e) => handleDrop(e, "Files")}
                  onDragOver={(e) => handleDragOver(e, "Files")}
                  onDragEnter={(e) => handleDragEnter(e, "Files")}
                  onDragLeave={(e) => handleDragLeave(e, "Files")}
                >
                  <input
                    type="file"
                    ref={FileInputRef}
                    className="fileUploadInput"
                    onChange={(e) => {
                      equipmentFilesHandleOnchange(e, "Files");
                    }}
                    multiple
                  />
                  <div>{localization.dragAndDropMessage}</div>
                  <div className="">
                    <img src="bootstrap_dist_new/bootstrap_dist/img/FileUploadPlusIcon.svg"></img>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center">
            <button type="submit" className="btn btn-primary saveBtnCls">
              {localization.saveEquipment}
            </button>
          </div>
        </form>
      );
    }
    setRenderMe(_renderMe);
  }, [renderBody, equipmentImagesData, equipmentFilesData]);

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "RISK_CONFIRMATION":
          ObjectUpdate(data.value.toString(), data.item);
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };
  return (
    <>
      <div className="container-fluid" id="content">
        <div className="page-header">
          <h2>
            <NavLink
              className={({ isActive }) => (isActive ? "active" : "")}
              to={"/equipmentGrpEqiupment"}
            >
              {sessionStorage.getItem("eqBez")}
            </NavLink>
            {" " + " / " + localization.addNewEquipment}{" "}
          </h2>
        </div>

        <div>
          <div className="table-responsive panel-body addEquipTableCls">
            {renderMe}
          </div>
        </div>
      </div>
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
        isCancelShow={false}
      />
    </>
  );
}
export default AddEquipment;
